import {
  STANDARD_SHIPPING_METHOD,
  COUNTRY_USA,
  CHECKOUT_SHIPPING_STEP,
  CHECKOUT_BILLING_STEP,
} from 'utils/constants';

export const defaultAuthenticationState = {
  isAuthenticated: false,
  account: '',
  accountId: '',
  endCustomerAccountId: '',
  varAccountId: '',
  ecomAccess: false,
  ecomCheckout: false,
  eCommerceAccess: [],
  userSFid: '',
  userType: '',
  userName: '',
};

export const defaultLoadingState = false;

export const defaultCurrentRmaState = {
  caseNumber: null,
  accountId: null,
  currencyCode: '',
  items: [],
};

export const defaultNotificationState = {
  text: '',
  show: false,
  type: 'success',
  timeout: null,
};

export const defaultInfoModalState = {
  open: false,
  config: {},
};

export const defaultLookupState = {
  itemAdded: false,
  lookupResults: [],
  selectedResult: null,
  failureDescription: {
    touched: false,
    value: '',
  },
  failureCode: {
    touched: false,
    value: '',
  },
  serviceActivity: {
    touched: false,
    value: '',
  },
  reviewRequested: false,
  reviewDescription: {
    touched: false,
    value: '',
  },
  presentPartSearch: false,
  searchedPartNumber: false,
  // Stores a copy of the result that will
  // be used as a reference
  incorrectResult: null,
  incorrectPartNumber: false,
};

export const defaultAccountState = {};

export const defaultCheckoutState = {
  currentStep: CHECKOUT_SHIPPING_STEP, //shipping | billing | review
  [CHECKOUT_SHIPPING_STEP]: {
    address: {
      id: null,
      address1: '',
      address2: '',
      city: '',
      state: '',
      zipcode: '',
      country: COUNTRY_USA,
    },
    method: STANDARD_SHIPPING_METHOD,
    packingInstructions: '',
    touched: false,
  },
  [CHECKOUT_BILLING_STEP]: {
    poNumber: '',
    touched: false,
  },
};

export const defaultCaseAssetsState = {
  attachments: [],
  comments: [],
  relationships: [],
};
